module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1139.c5042af4.png";